var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-full bg-gray-100" }, [
    _c("div", { staticClass: "flex items-center py-6 mx-4" }, [
      _c("h3", [_vm._t("title")], 2),
      _c("div", { staticClass: "ml-auto" }, [_vm._t("actions")], 2),
    ]),
    _c(
      "div",
      { staticClass: "p-4 m-4 mt-0 bg-white border rounded" },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }